// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialMainGroupState,
    MainGroupSchema,
    MainGroupFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";

const MainGroup = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [main_group, setMainGroup] = useState(InitialMainGroupState);
    const [formFields, setFormFields] = useState(MainGroupFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "multiselect")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getGroupHeaders = async () => {
        spinService.on();
        const response = await get(EntityConstants.GROUP_HEADERS, "max=all");
        const data = await response.json();
        attachOptions("group_header_id", data);
        spinService.off();
    };

    const getMainGroup = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.MAIN_GROUPS + `/${id}`);
        const data = await response.json();
        setMainGroup(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewMainGroup = values.id === undefined;
        const url = isNewMainGroup ? EntityConstants.MAIN_GROUPS : EntityConstants.MAIN_GROUPS + `/${values.id}`;
        const method = isNewMainGroup ? post : put;
        const response = await method(url, { main_group: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewMainGroup ? MessageContants.MAIN_GROUP_CREATED : MessageContants.MAIN_GROUP_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getGroupHeaders();
        if (id !== undefined) {
            getMainGroup(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={main_group}
            validationSchema={MainGroupSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.MAIN_GROUP_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.MAIN_GROUP_UPDATE))) &&

                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

MainGroup.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default MainGroup;
